import request from '@/utils/request'

/**
 * 搜索详情列表
 * @param {*} params
 */
export function getTaskNode(params) {
  return request({
    url: '/bsTaskNode',
    method: 'get',
    params: params
  })
}
/**
 * 添加
 * @param {*} params
 */
export function addTaskNode(params) {
  return request({
    url: '/bsTaskNode/save',
    method: 'post',
    data: params
  })
}
/**
 * 修改
 */
export function editTaskNode(params) {
  return request({
    url: '/bsTaskNode/update',
    method: 'put',
    data: params
  })
}
/**
 * 通过id删除
 */
export function deleteTaskNode(id) {
  return request({
    url: `/bsTaskNode/${id}`,
    method: 'delete',
  })
}
/**
 * 查看详情
 */
export function getTaskNodeInfo(id) {
  return request({
    url: `/bsTaskNode/${id}`,
    method: 'get'
  })
}
